import styled, { css, keyframes } from 'styled-components';

const spin = keyframes`
  to {
    transform: rotate(360deg);
  }
`;

export const StatusContainer = styled.div<{
  $compact: boolean;
  $status: 'loading' | 'refreshing' | 'empty' | 'error';
}>`
  align-items: center;
  color: ${({ theme, $status }) => ($status === 'error' ? theme.colors.danger : theme.colors.gray500)};
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  justify-content: center;
  min-height: ${({ $compact }) => ($compact ? 'auto' : '7.5rem')};
  padding: ${({ $compact }) => ($compact ? '0.5rem 1rem' : '1.5rem 1rem')};
  text-align: center;
  width: 100%;

  ${({ $compact }) =>
    $compact &&
    css`
      flex-direction: row;
    `}
`;

export const LoadingSpinner = styled.span<{ $compact: boolean }>`
  animation: ${spin} 0.8s linear infinite;
  border: 0.2rem solid ${({ theme }) => theme.colors.gray200};
  border-radius: 50%;
  border-top-color: ${({ theme }) => theme.colors.secondary500};
  display: inline-block;
  flex: 0 0 auto;
  height: ${({ $compact }) => ($compact ? '1.25rem' : '2rem')};
  width: ${({ $compact }) => ($compact ? '1.25rem' : '2rem')};

  @media (prefers-reduced-motion: reduce) {
    animation: none;
    border-color: ${({ theme }) => theme.colors.gray200};
    border-top-color: ${({ theme }) => theme.colors.secondary500};
  }
`;

export const StatusMessage = styled.p`
  line-height: 1.5;
  margin: 0;
`;
